import { render, staticRenderFns } from "./ProblemProcess.vue?vue&type=template&id=3f118e48&scoped=true&"
import script from "./ProblemProcess.vue?vue&type=script&lang=js&"
export * from "./ProblemProcess.vue?vue&type=script&lang=js&"
import style0 from "./ProblemProcess.vue?vue&type=style&index=0&id=3f118e48&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f118e48",
  null
  
)

export default component.exports